require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/$.core').Object.setPrototypeOf;


/*****************
 ** WEBPACK FOOTER
 ** /usr/src/sentry/~/react-bootstrap/~/babel-runtime/~/core-js/library/fn/object/set-prototype-of.js
 ** module id = 751
 ** module chunks = 0
 **/